/**
 * /tenants/$slug/agents/budget-reset-anomalies — the budget-reset anomaly fleet dashboard (AI Agents
 * / Agent governance area). Thin shim: validate the URL filter state, prefetch the first page, mount
 * the page. Read-only, observe-only (the detector is the only writer).
 */

import { createFileRoute } from "@tanstack/react-router";
import { anomaliesSearchSchema } from "@/features/agent-budget-reset-anomalies/schemas";
import { fetchAnomalies } from "@/features/agent-budget-reset-anomalies/queries";
import { queryKeys } from "@/lib/query-keys";
import { AnomalyDashboardPage } from "@/features/agent-budget-reset-anomalies/pages/anomaly-dashboard-page";

export const Route = createFileRoute("/_authed/tenants/$slug/agents/budget-reset-anomalies")({
  validateSearch: anomaliesSearchSchema,
  loaderDeps: ({ search }) => ({
    signature_kind: search.signature_kind,
    confidence: search.confidence,
    carried_forward: search.carried_forward,
    offset: search.offset ?? 0,
  }),
  loader: ({ context, deps }) =>
    context.queryClient.ensureQueryData({
      queryKey: queryKeys.agents.budgetResetAnomalies(context.tenant.id, deps),
      queryFn: () => fetchAnomalies(context.tenant.id, deps),
    }),
  component: AnomalyDashboardPage,
});
